import axios from 'axios';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Forgot_Password() {
    const [value, setvalue] = useState({ uname: '' });
    const [password, setpassword] = useState({ pass: '', cpass: '' });
    const [generatedCode, setGeneratedCode] = useState(null);
    const [userid, setuserid] = useState(null);
    const [code, setcode] = useState(0);
    const [isCodeSent, setIsCodeSent] = useState(true);

    const navigate = useNavigate();

    const handlename = (e) => {
        setvalue({ [e.target.id]: e.target.value })
    };
    const gen_code = async () => {
        if (value.uname !== '') {
            await axios.post(`/login/getcode`, value).then((res) => {
                setGeneratedCode(res.data.code);
                setuserid(res.data.id);
                toast.success('Verification code sent to your email.', { autoClose: 2000 });
            })
                .catch((err) => {
                    toast.error(err.response.data, { autoClose: 2000 });
                });
        }
        else {
            toast.error("Enter User Name", { autoClose: 2000 });
        }
    };
    const handle_code = (e) => {
        setcode(e.target.value);
    }
    const handle_code_submit = () => {
        if (code === generatedCode) {
            toast.success('Verification successful!', { autoClose: 2000 });
            setIsCodeSent(false);
        }
        else {
            toast.error('Invalid code, please try again.', { autoClose: 2000 });
        }
    }
    const handlepass = (e) => {
        setpassword({ ...password, [e.target.id]: e.target.value });
    }
    const handle_pass_submit = async () => {
        if (password.pass === password.cpass) {
            await axios.patch(`/login/updatepass/${userid}`, password).then((res) => {
                navigate('/');
            })
                .catch(() => {
                    toast.error('Password Could not be Updated', { autoClose: 2000 });
                })
        }
        else {
            toast.error('Check Password And Confirm Password', { autoClose: 2000 });
        }
    };
    return (
        <div className='Login_container v_blue df jc'>
            {/* <div className='h10 w100'></div> */}
            <div className='log_box df fdc jb ac'>
                <p className='h10 w100 df jc ac p'>Forgot Password</p>
                <p className='h10 w80 df ac g tac '>Enter Your User Name And We Will Send You Reset Verification Code On Your Mail Id.</p>
                {
                    isCodeSent &&
                    <div className='h30 w80 df fdc js ac '>
                        <div className='h8 w100 df jc ac'>
                            <input type='search' id='uname' placeholder='Enter User Name' onChange={handlename} className='w100 h5 b1 br025' />
                        </div>
                        <div className='h8 w100 df jc ac gap1'>
                            <input type='number' placeholder='Enter Code' className='w80 h5 b1 br025' onChange={handle_code} />
                            <button className='btn h5 blue' onClick={gen_code}>Get Code</button>
                        </div>
                    </div>
                }
                {
                    !isCodeSent &&
                    <div className='h15 w80 df fdc js ac'>
                        <div className='h8 w100 df jc ac'>
                            {/* <label htmlFor='pass'>New Password</label> */}
                            <input type='search' id='pass' placeholder='Enter New Password' onChange={handlepass} className='w100 h5 b1 br025' />
                        </div>
                        <div className='h8 w100 df jc ac'>
                            {/* <label htmlFor='cpass'>Con Password</label> */}
                            <input type='search' id='cpass' placeholder='Enter Confirm Password' onChange={handlepass} className='w100 h5 b1 br025' />
                        </div>
                    </div>
                }
                {
                    isCodeSent && <div className='h10 w100 df jc ac gap2'>
                        <Link to={'/'}><button className='closebtn'>Back</button></Link>
                        <button className='btn green' onClick={handle_code_submit}>Submit</button></div>
                }
                {
                    !isCodeSent && <div className='h10 w100 df jc ac'>
                        <Link to={'/'}><button className='closebtn'>Back</button></Link>
                        <button className='btn green' onClick={handle_pass_submit}>Update</button></div>
                }
            </div>
        </div>
    )
}

export default Forgot_Password;